export const createQS = (params):string => Object
    .entries(params)
    .map(([k, v]) => {
        if (v instanceof Array) {
            return v.map(it => `${k}=${it}`).join('&');
        }
        return `${k}=${v}`;
    })
    .join('&');

export const parseQS = <T extends {}>(qs: string): Partial<T> => qs
    .substring(1, qs.length)
    .split('&')
    .reduce((acc, it) => {
        const [key, value] = it.split('=');
        return { ...acc, [key]: decodeURIComponent(value) };
    }, {});
